import * as m from "./../../dist/es2015/xy.js";
export const am5xy = m;